
import './Preferential_Issue.css';

import useMeta from '../../../hooks/useMeta';


import { Link } from 'react-router-dom';
import Footer from "../../../CommonComponent/Footer/footer";
import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

const PrefIssueTwentyFour = () => {

    useMeta({
        title: 'Preferential Issue - 2024 | Marvel Blinds',
        description: "Statement of Deviation or Variation Complaince Certificate Reg.163 Outcome of Board Meeting_18_07_2024 Notice of EGM 14_08_2024 Attendence Slip Proxy Form Corrigendum to Notice of EGM Scrutinizer Report Proceedings of EGM 14_08_2024",
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/preferential-issue`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Preferential issue',
            description: "Statement of Deviation or Variation Complaince Certificate Reg.163 Outcome of Board Meeting_18_07_2024 Notice of EGM 14_08_2024 Attendence Slip Proxy Form Corrigendum to Notice of EGM Scrutinizer Report Proceedings of EGM 14_08_2024",
            url: `${process.env.REACT_APP_WEBSITE_URL}/preferential-issue`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="PI-pg-container">
                <h2 className="PI-pg-title">Preferential Issue - 2024</h2>
                <table className="PI-pg-content-table">
                    <tbody>
                        <tr>
                            <td className="even-row ">
                                <Link to="/statement-of-deviation-or-variation">
                                    Statement of Deviation or Variation
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/Compliance_Certificate_Reg_163.pdf">
                                    Complaince Certificate Reg.163
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/Outcome_of_Board_Meeting_18_07_2024.pdf">
                                    Outcome of Board Meeting_18_07_2024
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/Notice_of_EGM_14-08-2024.pdf  ">
                                    Notice of EGM 14_08_2024
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/Attendence_Slip.pdf">
                                    Attendence Slip
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/Proxy_FormPI.pdf">
                                    Proxy Form
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/Corrigendum_to_Notice_of_EGM.pdf">
                                    Corrigendum to Notice of EGM
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/Scrutinizer_Report.pdf">
                                    Scrutinizer Report
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/Proceeding_EGM_14082024 Signed.pdf">
                                    Proceedings of EGM 14_08_2024
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default PrefIssueTwentyFour;